export interface ICombinable<T> {
  merge(previous: T): boolean;
}

function groupBy<T>(entries: T[], groupFn: (a: T) => string) {
  const result: {[key: string]: T[]} = {};
  for (const entry of entries) {
    const groupKey = groupFn(entry);
    const group = result[groupKey] ?? (result[groupKey] = []);
    group.push(entry);
  }
  return result;
}

// almost immutable combine function (will combine combiguous portions within groups)
export function combine<T extends ICombinable<T>>(entries: T[], groupFn: (a: T) => string, sortFn: (a: T, b: T) => number) {
  if (entries.length <= 1) return entries;
  entries.sort(sortFn);
  const combinedGroups = groupBy(entries, groupFn);
  const results: T[] = [];
  for (const t of Object.values(combinedGroups)) {
    if (t.length === 1) {
      results.unshift(t[0]);
      continue;
    }
    let i       = t.length - 1;
    let current = t[i];
    while (i > 0) {
      const previous = t[i - 1];
      if (!current.merge(previous)) {
        results.unshift(current);
        current = previous;
      }
      i--;
    }
    results.unshift(current);
  }
  // results.sort(sortFn);
  return results;
}
